import PropTypes from 'prop-types'
import axios from 'axios'

import { kea } from 'kea'
import { put, call } from 'redux-saga/effects'

import omit from 'lodash/omit'
import isEmpty from 'lodash/isEmpty'
import mapValues from 'lodash/mapValues'
import has from 'lodash/has'
import map from 'lodash/map'
import isArrray from 'lodash/isArray'
import qs from 'qs'

import DataLogic from 'containers/App/logic'

import { API_BASE_URL } from 'config'

const LOCATIONS_ENDPOINT = `${API_BASE_URL}/public/municipality/`

const DEFAULT_FILTERS = {
  billing: ['any'],
  no_contract_duration: 'any',
}

const checkIfFiltersIsArray = (selected) =>
  isArrray(selected) ? map(selected, (e) => e.value) : selected.value

const transformLocations = (municipalities) => {
  const format = []
  municipalities.forEach((mun) => {
    const found = format.find((f) => f.value === mun.district.id)
    found && found.children.push({ value: mun.id, label: mun.name })
    if (!found) {
      format.push({
        label: mun.district.name,
        value: mun.district.id,
        children: [{ label: mun.name, value: mun.id }],
      })
    }
  })
  return format
}

const HandleExtras = (filters, value, condition) => {
  const extraFilter = has(filters, 'extra')
  let valueOnFilter = false
  let valIndex
  if (extraFilter) {
    valIndex = filters.extra.indexOf(value)
    valueOnFilter = valIndex > -1
  }

  if (extraFilter) {
    if (!valueOnFilter) {
      if (!condition) {
        filters.extra.push(value)
      } else {
        filters.extra.splice(valIndex, 1)
      }
    } else {
      if (condition) {
        filters.extra.splice(valIndex, 1)
      }
    }
  } else {
    if (!condition) {
      filters.extra = [value]
    }
  }
}

export default kea({
  actions: () => ({
    setFilter: (selected, item) => ({
      filter: { [item.fieldName]: checkIfFiltersIsArray(selected) },
    }),
    setFromUrl: (filters) => ({ filters }),
    triggerFilter: () => ({}),
    removeFilters: (filters) => ({ filters }),
    fetchLocations: (page) => ({ page }),
    setLocations: (locations) => ({ locations }),
    setLocationsFetchError: (fetchLocationError) => ({ fetchLocationError }),
    setSetterFlag: () => ({}),
  }),

  reducers: ({ actions }) => ({
    filters: [
      DEFAULT_FILTERS,
      PropTypes.object,
      {
        [actions.setFilter]: (state, payload) => ({
          ...state,
          ...payload.filter,
        }),
        [actions.removeFilters]: (state, payload) =>
          omit(state, payload.filters),
        [actions.setFromUrl]: (state, payload) => ({
          ...state,
          ...payload.filters,
        }),
      },
    ],

    locations: [
      [],
      PropTypes.array,
      {
        [actions.setLocations]: (state, payload) => [
          ...state,
          ...payload.locations,
        ],
      },
    ],

    setterFromUrl: [
      false,
      PropTypes.bool,
      {
        [actions.setFromUrl]: () => true,
        [actions.setSetterFlag]: () => true,
      },
    ],
  }),

  takeLatest: ({ actions, workers }) => ({
    [actions.setFilter]: workers.setBrowserHistory,
    [actions.fetchLocations]: workers.fetchLocations,
  }),

  start: function*() {
    const { setFromUrl, fetchLocations, setSetterFlag } = this.actions

    yield put(fetchLocations(1))

    /* eslint-enable camelcase */

    const URLQuery = window.location.search.substring(1)
    let filtersfromQuery = qs.parse(URLQuery, { strictNullHandling: true })

    // Parses number/bools fields correctly
    filtersfromQuery = mapValues(filtersfromQuery, (filter) => {
      if (filter === 'true') {
        return true
      }

      const convertToNumber = Number(filter)
      // eslint-disable-next-line eqeqeq
      return convertToNumber == filter ? convertToNumber : filter
    })

    // Hides additonal services
    /* eslint-disable camelcase */
    const { hide_additional } = yield DataLogic.get('values')
    HandleExtras(filtersfromQuery, 'as', hide_additional)

    if (!isEmpty(filtersfromQuery)) {
      yield put(setFromUrl(filtersfromQuery))
    } else {
      yield put(setSetterFlag())
    }
  },

  workers: {
    *setBrowserHistory(action) {
      const filters = yield this.get('filters')
      const query = qs.stringify(filters, { strictNullHandling: true })
      const url = `?${query}`
      window.history.pushState('', '', url)
    },

    *fetchLocations(action) {
      const { page } = action.payload
      const { setLocations, setLocationsFetchError } = this.actions
      const params = { page, limit: 1000 }

      try {
        const locations = yield call(axios.get, LOCATIONS_ENDPOINT, { params })

        const filteredLocations = transformLocations(locations.data.results)
        yield put(setLocations(filteredLocations))
      } catch (error) {
        yield put(setLocationsFetchError(error))
      }
    },
  },
})



// WEBPACK FOOTER //
// ./src/containers/Filters/logic.js